
import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RoutingService } from '@spartacus/core';

@Component({
  selector: 'custom-redirect',
  template: '',
  imports: [RouterModule],
})
export class CustomRedirectComponent implements OnInit {
  routingService = inject(RoutingService);

  ngOnInit(): void {
    this.routingService.go({ cxRoute: 'search', params: { query: '::' } });
  }
}
